import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/download'
  },
  {
    path: '/register',
    component: () => import('../views/Register')
  },
  {
    path: '/word/agreement',
    component: () => import('../views/word/Agreement')
  },
  {
    path: '/word/policy',
    component: () => import('../views/word/Policy')
  },
  {
    path: '/download',
    component: () => import('../views/Download')
  },
  {
    path: '/product/elantra_n',
    component: () => import('../views/product/ElantraN')
  },
  {
    path: '/activity/trackday',
    component: () => import('../views/activity/TrackDay')
  },
  {
    path: '/activity/hdx',
    component: () => import('../views/activity/HDX')
  },
  {
    path: '/activity/nlounge',
    component: () => import('../views/activity/Nlounge')
  },
  {
    path: '/activity/drive',
    component: () => import('../views/activity/Drive')
  },
  {
    path: '/ncity/address',
    component: () => import('../views/ncity/Address')
  },
  {
    path: '/ncity/speed',
    component: () => import('../views/ncity/Speed')
  },
  {
    path: '/product/5n',
    component: () => import('../views/product/5N')
  },
  {
    path: '/activity/video',
    component: () => import('../views/activity/Video')
  },
  {
    path: '/activity/ncity',
    component: () => import('../views/activity/Ncity')
  }
]

const router = new VueRouter({
  routes
})

export default router
